import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getCargoTypes } from 'actions/cargoes/types';
import CircularProgress from 'material-ui/CircularProgress';
import styles from 'styles/index';

import TCRequestsList from './List';

class TimeCharterRequests extends React.PureComponent {

    componentDidMount() {
        this.props.getCargoTypes();
    }

    render() {
        const { isLoaded } = this.props;

        return (
            <div id='cargo-requests' className='requests-page page'>
                <CircularProgress
                    className={!isLoaded ? '' : 'hidden'}
                    style={styles.circularProgress}
                />

                <div className={this.props.isLoaded ? '' : 'hidden'}>
                    <div className='container'>
                        <h2>
                            Timecharter requests
                        </h2>
                        <TCRequestsList />
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    ({ tcRequests : { isLoaded }}) => {
        return {
            isLoaded,
        };
    },
    dispatch => bindActionCreators({
        getCargoTypes,
    },
    dispatch),
)(TimeCharterRequests);



// WEBPACK FOOTER //
// ./app/components/TimeCharter/Requests/Page.jsx